import { EAppTemplateType } from "templates-common-library/baseClasses/CompatibilityChecker";

export const AppType_to_T9NKey = {
  [EAppTemplateType.ThreeDViewer]: "3d",
  [EAppTemplateType.Atlas]: "atlas",
  [EAppTemplateType.AttachmentViewer]: "av",
  [EAppTemplateType.Basic]: "basic",
  [EAppTemplateType.CategoryGallery]: "catGal",
  [EAppTemplateType.Charts]: "charts",
  [EAppTemplateType.Countdown]: "countdown",
  [EAppTemplateType.Exhibit]: "exhibit",
  [EAppTemplateType.ImageryApp]: "imageView",
  [EAppTemplateType.Insets]: "insets",
  [EAppTemplateType.InteractiveLegend]: "intLeg",
  [EAppTemplateType.Manager]: "manager",
  [EAppTemplateType.Media]: "media",
  [EAppTemplateType.Minimalist]: "minimalist",
  [EAppTemplateType.Nearby]: "nearby",
  [EAppTemplateType.Notify]: "notify",
  [EAppTemplateType.Observer]: "observer",
  [EAppTemplateType.Portfolio]: "portfolio",
  [EAppTemplateType.Reporter]: "reporter",
  [EAppTemplateType.Sidebar]: "sidebar",
  [EAppTemplateType.Slider]: "slider",
  [EAppTemplateType.Streamflow]: "streamflow",
  [EAppTemplateType.ZoneLookup]: "zoneLook",
};

export interface AppTypeInfoModalProperties extends __esri.WidgetProperties {
  portal: __esri.Portal;
  picUrl: string;
  /** Ex: "Media", "Attachment Viewer", ...etc */
  appTypeTitle: string;
  appTypeUrlFragment: string;
  sendFocusOnClose: Function;
}

export const AppType_Examples = {
  [EAppTemplateType.ThreeDViewer]: [
    "https://webapps.maps.arcgis.com/apps/instant/3dviewer/index.html?appid=f8f033ebe886416aa1f829c173c44ec9",
    "https://webapps.maps.arcgis.com/apps/instant/3dviewer/index.html?appid=087f7581b31e4f3188d6e5e5728153ec",
    "https://webapps.maps.arcgis.com/apps/instant/3dviewer/index.html?appid=3e1b3cbad2af495b9f1a2f11ce355d57",
  ],
  [EAppTemplateType.Atlas]: [
    null,
    "https://webapps.maps.arcgis.com/apps/instant/atlas/index.html?appid=a285bccddd8e4f4aa968353c83e403a6",
    "https://webapps.maps.arcgis.com/apps/instant/atlas/index.html?appid=c4f3f903194e4f9d9f1704e2140db114",
  ],
  [EAppTemplateType.AttachmentViewer]: [
    null,
    "https://webapps.maps.arcgis.com/apps/instant/attachmentviewer/index.html?appid=965a10a15c7e47fb98192a06c1526215",
    "https://webapps.maps.arcgis.com/apps/instant/attachmentviewer/index.html?appid=6c1ca6f5665e4353939ff4dbe6a72cc8",
  ],
  [EAppTemplateType.Basic]: [
    "https://webapps.maps.arcgis.com/apps/instant/basic/index.html?appid=cd8ff64c34f24cf5987135e5768ea287",
    "https://webapps.maps.arcgis.com/apps/instant/basic/index.html?appid=1f2fa2dc4eee498a9876ac251a39ef8a",
    "https://webapps.maps.arcgis.com/apps/instant/basic/index.html?appid=97501d1ba96742caa59e6873a563a684",
  ],
  [EAppTemplateType.CategoryGallery]: [
    "https://webapps.maps.arcgis.com/apps/instant/filtergallery/index.html?appid=20f576ec17bd491995a1ca41581d8025",
    null,
    "https://webapps.maps.arcgis.com/apps/instant/filtergallery/index.html?appid=62501a97d4594392a4d7fa53602c9357",
  ],
  [EAppTemplateType.Charts]: [
    "https://webapps.maps.arcgis.com/apps/instant/charts/index.html?appid=898d2ccaf57d4de781a79f60b863af82",
    "https://webapps.maps.arcgis.com/apps/instant/charts/index.html?appid=588fb9ee83ad44e2b47da04675e62dd6",
    "https://webapps.maps.arcgis.com/apps/instant/charts/index.html?appid=de84e540988e4ebcb98b36068b85660b",
  ],
  [EAppTemplateType.Countdown]: [
    "https://webapps.maps.arcgis.com/apps/instant/countdown/index.html?appid=013bc811553c44b38d16096056971012",
    "https://webapps.maps.arcgis.com/apps/instant/countdown/index.html?appid=760ed55aa1fd46c6ada33695f5438ddc",
    "https://webapps.maps.arcgis.com/apps/instant/countdown/index.html?appid=8baeb39b0ac04fe3bb61ca3ea5165062",
  ],
  [EAppTemplateType.Exhibit]: [
    "https://webapps.maps.arcgis.com/apps/instant/exhibit/index.html?appid=12dc0b2c24dc452db36d6c3295abd722",
    "https://webapps.maps.arcgis.com/apps/instant/exhibit/index.html?appid=02a6d796d308475d861fb56eebbcaef1",
    null,
  ],
  [EAppTemplateType.ImageryApp]: [
    "https://webapps.maps.arcgis.com/apps/instant/imageryviewer/index.html?appid=eab4ae267892435ba163c4c2de13c7dd",
    null,
    null,
  ],
  [EAppTemplateType.Insets]: [
    "https://webapps.maps.arcgis.com/apps/instant/insets/index.html?appid=c11925fa55e24342b45e00d9404df4ca",
    "https://webapps.maps.arcgis.com/apps/instant/insets/index.html?appid=f42477d0722a42deaecf9b74770c9693",
    "https://webapps.maps.arcgis.com/apps/instant/insets/index.html?appid=e95a4fff73b445cba6ae20849b921ad2",
  ],
  [EAppTemplateType.InteractiveLegend]: [
    "https://webapps.maps.arcgis.com/apps/instant/interactivelegend/index.html?appid=d1ae3048bfa248a092217290eb230491",
    "https://webapps.maps.arcgis.com/apps/instant/interactivelegend/index.html?appid=e4a4a77c66d84d6eb5f537c1fbcbef92",
    "https://webapps.maps.arcgis.com/apps/instant/interactivelegend/index.html?appid=d2aac371f7a14713947f5aaf7dcffa45",
  ],
  [EAppTemplateType.Manager]: [
    "https://webapps.maps.arcgis.com/apps/instant/manager/index.html?appid=a969252a09ad403c804d756bfdc04de2",
    null,
    null,
  ],
  [EAppTemplateType.Media]: [
    "https://webapps.maps.arcgis.com/apps/instant/media/index.html?appid=a4f50e7bbca64da4a9ca75c85f3282be",
    "https://webapps.maps.arcgis.com/apps/instant/media/index.html?appid=9569c8fc30c146d5bb7cb265e801a121",
    "https://webapps.maps.arcgis.com/apps/instant/media/index.html?appid=97116b15d6c34478aaa0caea92cc9bac",
  ],
  [EAppTemplateType.Minimalist]: [null, null, null],
  [EAppTemplateType.Nearby]: [
    "https://webapps.maps.arcgis.com/apps/instant/nearby/index.html?appid=de80c67518fe4f10bdebfa228716668d",
    "https://webapps.maps.arcgis.com/apps/instant/nearby/index.html?appid=1e3848a0ca2e4c5bb4a324854b0c846e&sliderDistance=1",
    "https://webapps.maps.arcgis.com/apps/instant/nearby/index.html?appid=3b2faa2735f84d7ca1566aceaf6cd0ca",
  ],
  [EAppTemplateType.Notify]: [
    "https://webapps.maps.arcgis.com/apps/instant/notification/index.html?appid=4fef3c6327cf423a9db4c51732e95dbd",
    null,
    "https://webapps.maps.arcgis.com/apps/instant/notification/index.html?appid=4bdc56273e454e1299b00ec9fbf1bdd2",
  ],
  [EAppTemplateType.Observer]: [
    null,
    "https://webapps.maps.arcgis.com/apps/instant/observer/index.html?appid=835e2da473f54b588d4dae163588636a",
    null,
  ],
  [EAppTemplateType.Portfolio]: [
    "https://webapps.maps.arcgis.com/apps/instant/portfolio/index.html?appid=ca4f9139664842f0879f28d0a7cc4d5c",
    "https://webapps.maps.arcgis.com/apps/instant/portfolio/index.html?appid=837d743a979b4fe4bf5b3203f512a72e",
    "https://webapps.maps.arcgis.com/apps/instant/portfolio/index.html?appid=5da3b90f436a400fb52c4bd271e9892c",
  ],
  [EAppTemplateType.Reporter]: [
    "https://webapps.maps.arcgis.com/apps/instant/reporter/index.html?appid=9fcb3b2071194dd499c9b5a8a87dba38",
    null, 
    null
  ],
  [EAppTemplateType.Sidebar]: [
    "https://webapps.maps.arcgis.com/apps/instant/sidebar/index.html?appid=877c93ae06174a42b9e3e8ec21c43b88",
    "https://webapps.maps.arcgis.com/apps/instant/sidebar/index.html?appid=dc91be9ae0bd4b93ab69c08a10ef4a67",
    "https://webapps.maps.arcgis.com/apps/instant/sidebar/index.html?appid=048d7915ea624b5fb8142c33442d8a43",
  ],
  [EAppTemplateType.Slider]: [
    "https://webapps.maps.arcgis.com/apps/instant/slider/index.html?appid=79f221262a6b46fba79754cbdd98a103",
    "https://webapps.maps.arcgis.com/apps/instant/slider/index.html?appid=b3f23d1cb664424caa4655b27b8155b9",
    "https://webapps.maps.arcgis.com/apps/instant/slider/index.html?appid=e4a20e8ee2c94524bd9721f48bbb4fb1",
  ],
  [EAppTemplateType.Streamflow]: [
    "https://nw-brews.mapsdevext.arcgis.com/apps/instant/streamflowviewer/index.html?appid=0372fad0ef374d579b2541f8c65655f6",
    null,
    null,
  ],
  [EAppTemplateType.ZoneLookup]: [
    "https://webapps.maps.arcgis.com/apps/instant/lookup/index.html?appid=55399b7373b94ecd99d94e73bd46131a",
    "https://webapps.maps.arcgis.com/apps/instant/lookup/index.html?appid=2cfcf6bb0fc9424ba33c051d30fec4cb",
    "https://webapps.maps.arcgis.com/apps/instant/lookup/index.html?appid=9d92f22c80b44852982014973375d2cf",
  ],
};
